(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('featureFlagsService', featureFlagsService);

  function featureFlagsService(
    ngAuthSettings,
    promiseCacheService,
    featureFlags,
    envFeatures,
    VuexStore,
    VuexMutationTypes,
    pvtUtils,
  ) {
    'ngInject';

    const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

    // Initialize pvt session override from URL params (once per page load)
    pvtUtils.initPvtOverride(envFeatures.pvt, window.location, window.sessionStorage);

    const service = {
      getFeatureFlags: getFeatureFlags,
      disableAllFeatureFlags: disableAllFeatureFlags,
      setFeatureFlags: setFeatureFlags
    };

    return service;

    function getFeatureFlags(accountId) {
      const url = _serviceBaseUrl(accountId);
      return promiseCacheService.getCallWithCachedPromise(url, url, 120)
        .catch(function () {
          return { data: { featureToggles: {} } };
        })
        .then(function (response) {
          const featureFlags = response.data.featureToggles;
          const flagsToAdd = [];
          _.forEach(featureFlags, function (value, key) {
            flagsToAdd.push({
              key: key,
              active: value > 0
            });
          });

          return applyPvtOverride(flagsToAdd);
        });
    }

    // DEV ONLY: Override portal_v3 flag based on pvt config + session opt-out (?__pvt_off/?__pvt_on).
    // Applied regardless of flipper success/failure so a forced pvt survives a failed request.
    function applyPvtOverride(flagsToAdd) {
      const pvtOverride = pvtUtils.resolvePvtOverride(envFeatures.pvt, window.sessionStorage);
      if (pvtOverride === true) {
        flagsToAdd.push({
          key: 'portal_v3',
          active: true,
        });
      } else if (pvtOverride === false) {
        flagsToAdd = flagsToAdd.filter(function(f) { return f.key !== 'portal_v3'; });
      }

      return flagsToAdd;
    }

    function disableAllFeatureFlags() {
      if (featureFlags && featureFlags.get()) {
        const flagsToDisable = featureFlags.get().map(function (flag) {
          return { key: flag.key, active: false };
        });
        featureFlags.set(flagsToDisable);
      }
    }

    function setFeatureFlags(accountId) {
      if (featureFlags && featureFlags.get()) {
        const currentAccountFeatureFlags = getFeatureFlags(accountId);

        setVuexCurrentAccountFeatureFlags(currentAccountFeatureFlags);

        return featureFlags.set(currentAccountFeatureFlags);
      }

      return true;
    }

    function setVuexCurrentAccountFeatureFlags(currentAccountFeatureFlags) {
      const currentAccountFeatureFlagsObject = {};

      currentAccountFeatureFlags.then(function (response) {
        response.forEach(function (caff) {
          currentAccountFeatureFlagsObject[caff.key] = caff.active;
        });
      });

      VuexStore.commit(VuexMutationTypes.SET_CURRENT_ACCOUNT_FEATURE_FLAGS, currentAccountFeatureFlagsObject);
    }

    function _serviceBaseUrl(accountId) {
      return serviceBaseUri + accountId + '/flipper';
    }
  }
})();
